module.exports = __webpack_public_path__ + "static/about-9f73cd20fd202df4a31a87a95eb41655.jpg";